export default function LegalLayout({ eyebrow, title, lastUpdated, children }) {
    return (
        <div className="max-w-3xl mx-auto px-6 sm:px-8 py-16 sm:py-24">
            <header className="text-center mb-14">
                <p className="eyebrow">{eyebrow}</p>
                <h1 className="headline mt-4 text-4xl sm:text-5xl">{title}</h1>
                {lastUpdated && (
                    <p className="mt-4 text-sm text-[#8a807b] italic">
                        Última actualización: {lastUpdated}
                    </p>
                )}
            </header>
            <article className="legal-content space-y-6 text-[1.02rem] leading-[1.8] text-[#3c3531]">
                {children}
            </article>
        </div>
    );
}

export function LegalH2({ children }) {
    return (
        <h2 className="headline text-2xl sm:text-[1.75rem] mt-12 mb-3 text-[#2d2a28]">
            {children}
        </h2>
    );
}

export function LegalP({ children }) {
    return <p className="text-[#5c5450]">{children}</p>;
}

export function LegalList({ items }) {
    return (
        <ul className="space-y-2 list-none pl-0">
            {items.map((item, i) => (
                <li
                    key={i}
                    className="text-[#5c5450] pl-6 relative before:content-[''] before:absolute before:left-0 before:top-[0.65rem] before:w-2 before:h-2 before:rounded-full before:bg-[#d4909e]"
                >
                    {item}
                </li>
            ))}
        </ul>
    );
}
